import { ROUTE_NAMES } from '@/utils/const.js';
import { USER_ACTIONS, USER_SUBJECTS } from '@/utils/const';
const Templates = () => import('./pages');

const moduleRoute = {
  path: 'master-data/templates',
  name: 'Templates',
  component: Templates,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.REPORT_TEMPLATE,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
